<script setup lang="ts">
import { watch, onBeforeUnmount, computed } from 'vue'
import {
  IonButtons,
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
} from '@ionic/vue'
import FeButton from '@/components/global/button.vue'
import FeIcon from '@/components/global/icon.vue'
// import e const per i componenti passati dinamicamente, non rimuovere
import FeExternalLinks from '@/components/sidebar/left-drawer-externllink.vue'
import FeLeftDrawerNotifications from '@/components/notifications-list/notifications.vue'
const components = {
  FeExternalLinks,
  FeLeftDrawerNotifications,
}
const activeComponent = computed(() => {
  return components[props.component as keyof typeof components] || null
})
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  name: {
    type: String,
    default: () => 'menu-left',
  },
  title: {
    type: String,
    default: () => '',
  },
  component: {
    type: String,
    default: () => '',
  },
})

const emit = defineEmits(['update:modelValue'])

const onClose = (): void => {
  emit('update:modelValue', false)
}

// La rimozione della classe avviene DOPO la transizione
const afterLeave = (): void => {
  document.body.classList.remove('backdrop-no-scroll')
}

watch(
  () => props.modelValue,
  (newValue) => {
    if (newValue) {
      document.body.classList.add('backdrop-no-scroll')
    }
  },
  { immediate: true },
) // immediate: true assicura che il watcher venga eseguito subito

onBeforeUnmount(() => {
  // Remove overflow: hidden style when component is unmounted
  document.body.classList.remove('backdrop-no-scroll')
})
</script>

<template>
  <div v-if="props.modelValue" class="fe-drawer-layer" @click="onClose"></div>
  <!-- do not import because importing causes the ion-menu open method to not work -->
  <transition name="drawer-left-" @after-leave="afterLeave">
    <div v-if="props.modelValue" class="fe-drawer-left__container">
      <ion-header>
        <ion-toolbar>
          <ion-title>{{ $t(title) }}</ion-title>
          <ion-buttons slot="end">
            <fe-button color="icon" @click="onClose">
              <fe-icon class="header__icon" icon="close" />
            </fe-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <component :is="activeComponent" @close="onClose"></component>
      </ion-content>
    </div>
  </transition>
</template>

<style lang="scss">
.backdrop-no-scroll ion-app.ion-page {
  overflow: hidden !important;
}
.fe-drawer-left__container ion-content {
  > div > div,
  ion-list {
    padding-bottom: 6rem !important;
  }
}
</style>

<style lang="scss" scoped>
@import '@/styles/_constants.scss';
@import '@/styles/_mixins.scss';
.fe-drawer {
  &-layer {
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    top: 4.9rem;
    left: 6.3rem;
    @include z-index('modal', -1);
  }
  &-left {
    &__container {
      top: 49px;
      left: 63px;
      box-shadow: -0.1rem 0.5rem 1.6rem 0 #aaaaaa;
      transition: all 0.3s ease-in-out;
      position: fixed;
      width: 57%;
      bottom: 0;
      height: 88%;
      height: calc(100vh - 10.5rem);
      @include z-index('modal');
      @include tablet-small {
        // height: 92%;
        height: calc(100vh - 9.3rem);
      }
      @include desktop {
        // height: 92%;
        height: calc(100vh - 9.3rem);
      }
    }
  }
}
.drawer-left {
  &--enter-from,
  &--leave-to {
    opacity: 0;

    &.fe-drawer-left__container {
      transform: translateX(-100%);
    }
  }

  &--leave-from,
  &--enter-to {
    opacity: 1;

    &.fe-drawer-left__container {
      transform: translateX(0%);
    }
  }
}
ion-header {
  box-shadow: 0 0.2rem 3.2rem rgba(0, 0, 0, 0.1);
}
ion-title {
  font-size: 2rem;
}
</style>
